const doc = [({"da":({"js":({"admin":({"photo_colors":({"create_card":({"create_photo_color":"Opret fotofarve"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;